<template>
  <w-icon-wrapper
    :height='20'
    :width='24'
    icon-name='barcode-readable-icon'
    view-box='0 0 24 20'
  >
    <g fill='currentColor'>
      <rect
        x='3'
        y='0'
        width='1.5'
        height='16'
        rx='0.75'
      />
      <rect
        x='5.5'
        y='0'
        width='1'
        height='16'
        rx='0.5'
      />
      <rect
        x='7.5'
        y='0'
        width='2'
        height='16'
        rx='1'
      />
      <rect
        x='10.5'
        y='0'
        width='1'
        height='16'
        rx='0.5'
      />
      <rect
        x='12.5'
        y='0'
        width='1.5'
        height='16'
        rx='0.75'
      />
      <rect
        x='15'
        y='0'
        width='1'
        height='16'
        rx='0.5'
      />
      <rect
        x='17'
        y='0'
        width='2'
        height='16'
        rx='1'
      />
      <rect
        x='20'
        y='0'
        width='1'
        height='16'
        rx='0.5'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconSerialNumber' };
</script>